import { jsxs as f, Fragment as S, jsx as a } from "react/jsx-runtime";
import { useState as d, useEffect as N } from "react";
import { ConfigService as Z } from "@nextgen-web-framework/core";
import { useTranslation as ee, useSession as ae, useMasterData as te, AlertMessage as re, Theme as u, IconStyle as I, Checkbox as oe, FAIcon as se, CardRadioButton as ne, MLPVersion as A, Input as ce, InputTypes as ie, LinkTarget as de, TextLink as le, TextLinkStyle as he, TextLinkUnderlineStyle as ue, InputValidations as k } from "@nextgen-web-framework/all";
import { sharebarApi as me } from "@commerce-webcomponents/sdk";
import { getSharePath as ge, createSharecode as pe } from "../../utils/sharebar/sharebarHelpers.js";
import fe from "../SocialLinks/SocialLinks.js";
import '../../assets/ShareModal.css';var v = /* @__PURE__ */ ((m) => (m.REQUIRED = "REQUIRED", m.OPTIONAL = "OPTIONAL", m))(v || {});
const be = "#ffffff", Ce = "#396e75", we = "#e5fdff", Ve = "#546223", _e = "#f0fae5", ke = "#a65523", ze = "#fff1e8", xe = "#7f3e3e", Re = "#ffe2e2", Te = "#62625a", ye = "#f8f8e7", Le = "#38539a", Ee = "#707070", Oe = "#c8f8d1", Se = "#87c9c8", Ne = "#5291b1", Ie = "rgba(82, 145, 177, 0.1019607843)", Ae = "#445685", ve = "#181d61", Be = "rgba(24, 29, 97, 0.1019607843)", je = "#5969d6", Me = "#ea999d", Ge = "#b6577e", $e = "rgba(182, 87, 126, 0.1019607843)", Pe = "#7e3e80", Ue = "#1e247f", We = "rgba(30, 36, 127, 0.1019607843)", Fe = "#da7600", He = "#107f47", De = "#d91734", Ye = "_html_ij66w_38", s = {
  amwayWhite: be,
  darkBlue: Ce,
  lightBlue: we,
  darkGreen: Ve,
  lightGreen: _e,
  darkOrange: ke,
  lightOrange: ze,
  darkRed: xe,
  lightRed: Re,
  darkYellow: Te,
  lightYellow: ye,
  darkPurple: Le,
  darkGrayOnWhite: Ee,
  dataVizColor1: Oe,
  dataVizColor2: Se,
  dataVizColor3: Ne,
  dataVizColor3Background: Ie,
  dataVizColor4: Ae,
  dataVizColor5: ve,
  dataVizColor5Background: Be,
  dataVizColor6: je,
  dataVizColor7: Me,
  dataVizColor8: Ge,
  dataVizColor8Background: $e,
  dataVizColor9: Pe,
  dataVizColor10: Ue,
  dataVizColor10Background: We,
  dataVizAlertOrange: Fe,
  dataVizSuccessGreen: He,
  dataVizWarningRed: De,
  "no-visible": "_no-visible_ij66w_34",
  html: Ye,
  "social-share-modal-wrapper": "_social-share-modal-wrapper_ij66w_72",
  "sharebar-close-button": "_sharebar-close-button_ij66w_77",
  "custom-input-wrapper": "_custom-input-wrapper_ij66w_94",
  "sharebar-radio-title": "_sharebar-radio-title_ij66w_98",
  "sharebar-radio-title-checked": "_sharebar-radio-title-checked_ij66w_105",
  "sharebar-sub-text": "_sharebar-sub-text_ij66w_112",
  "reg-details-wrapper": "_reg-details-wrapper_ij66w_120",
  "alert-msg-padding": "_alert-msg-padding_ij66w_130",
  "sharebar-custom-url-wrapper": "_sharebar-custom-url-wrapper_ij66w_141",
  "sharebar-customize-url": "_sharebar-customize-url_ij66w_150",
  "checkbox-text-wrapper": "_checkbox-text-wrapper_ij66w_159"
}, ta = ({
  showDescription: m = !0,
  socialIconsVisibility: z,
  isCustomUrl: V,
  linkProps: g,
  shareTextMessage: B,
  shareDescriptionContent: j
}) => {
  var O;
  const n = ee(), { isABO: M } = ae(), [G, x] = d(!1), [b, $] = d(!1), [P, U] = d(!1), l = te("WebshopConfigs"), W = Z.getConfigs(), c = l == null ? void 0 : l.shareRegistrationData, _ = (l == null ? void 0 : l.shareRegistrationConfig)[(g == null ? void 0 : g.category) ?? ""], R = _ === v.REQUIRED, [F, H] = d(!1), [C, T] = d(
    R ? (O = c == null ? void 0 : c[0]) == null ? void 0 : O.type : void 0
  ), [r, y] = d(), [t, p] = d({
    showInput: !1,
    inputText: "",
    error: !1,
    customSharecodeValidated: !1
  }), D = () => /* @__PURE__ */ a(S, { children: c == null ? void 0 : c.map((e) => {
    const o = C === e.type;
    return /* @__PURE__ */ a(
      ne,
      {
        mlpVersion: A.ONE,
        label: /* @__PURE__ */ a("span", { className: o ? s["sharebar-radio-title-checked"] : "sharebar-radio-title", children: n(e.labelKey) }),
        theme: o ? u.PURPLE : u.BLACK,
        checked: o,
        onChange: () => {
          T(e.type), x(!1), V && E();
        }
      },
      e.type
    );
  }) }), Y = async () => {
    try {
      const e = {
        sharecodeid: r == null ? void 0 : r.sharecodeid,
        sharecode: r == null ? void 0 : r.sharecode,
        customsharecode: t.inputText
      }, o = await me.updateCustomSharecode({
        payload: {
          ...e
        }
      });
      "sharecode" in o && (y({ sharecode: o.sharecode, sharecodeid: o.sharecodeid }), p({ ...t, customSharecodeValidated: !0, error: !1 }));
    } catch {
      p({ ...t, customSharecodeValidated: !0, error: !0 });
    }
  }, K = () => {
    const e = ge(
      void 0,
      W.NEXT_SHARELINK_DOMAIN,
      z.sharelinkPath
    ), o = 20, w = () => {
      let i = "", h = k.DEFAULT;
      return t.customSharecodeValidated && !t.error ? (i = n("web.share.url.available.msg"), h = k.VALID) : t.error && (i = n("web.share.url.not.available.msg"), h = k.INVALID), { customMsg: i, inputStatus: h };
    }, X = (i) => {
      var h;
      t.inputText && ((h = i.relatedTarget) == null ? void 0 : h.id) !== "btn_cancel" && Y();
    }, { customMsg: q, inputStatus: J } = w();
    return /* @__PURE__ */ f("div", { className: s["sharebar-custom-url-wrapper"], children: [
      /* @__PURE__ */ a("div", { className: `${s["sharebar-customize-url"]}`, children: /* @__PURE__ */ a("span", { children: `${e}/${t.inputText === "" || t.error !== null || t.customSharecodeValidated === !1 ? `${(r == null ? void 0 : r.sharecode) ?? ""}` : t.inputText}` }) }),
      t.showInput ? /* @__PURE__ */ a("div", { className: s["custom-input-wrapper"], children: /* @__PURE__ */ a(
        ce,
        {
          type: ie.TEXT,
          "data-testid": "custom-input-box",
          "data-pod-name": "commerce",
          autoFocus: !0,
          name: "customBox",
          label: n("web.share.customize.back.half"),
          value: t.inputText,
          message: q,
          onChange: (i) => p({ ...t, inputText: i.target.value }),
          onBlur: X,
          status: J,
          mlpVersion: A.TWO,
          maxLength: o,
          ctaTextLink: {
            id: "btn_cancel",
            text: "Cancel",
            onClick: () => p({
              showInput: !1,
              inputText: "",
              error: !1,
              customSharecodeValidated: !1
            }),
            target: de.SELF
          }
        }
      ) }) : /* @__PURE__ */ a(
        le,
        {
          textLinkStyle: he.ICON,
          text: "Customize URL",
          theme: u.PURPLE,
          onClick: () => p({ ...t, showInput: !0 }),
          underline: ue.NOHOVER,
          leftIcon: { iconName: "pen", iconStyle: I.REGULAR }
        }
      )
    ] });
  }, L = b || R, E = async () => {
    const e = await pe({ linkProps: g, regType: C });
    e || U(!0), y({ sharecode: e == null ? void 0 : e.sharecode, sharecodeid: e == null ? void 0 : e.sharecodeid });
  }, Q = () => b && !C ? (x(!0), !0) : !1;
  return N(() => {
    V && E();
  }, []), N(() => {
    H(!0);
  }, []), /* @__PURE__ */ f(S, { children: [
    P && /* @__PURE__ */ f("div", { className: `${s["alert-msg-padding"]}`, "data-testid": "alert-error-msg", "data-pod-name": "commerce", children: [
      /* @__PURE__ */ a(
        re,
        {
          className: `${s["alert-msg-padding"]}`,
          content: {
            detail: n("web.share.error.heading"),
            heading: n("web.share.error.detail")
          },
          hasIcon: !0,
          icon: "square-exclamation",
          iconColor: u.ERROR,
          iconStyle: I.REGULAR,
          theme: u.ERROR
        }
      ),
      " "
    ] }),
    m && F && /* @__PURE__ */ a("div", { className: `${s["sharebar-sub-text"]}`, children: /* @__PURE__ */ a("span", { children: j ?? (M() ? n("web.share.abo.desc") : n("web.share.non.abo.desc")) }) }),
    (_ === "OPTIONAL" || L) && /* @__PURE__ */ f("div", { className: s["reg-details-wrapper"], children: [
      _ === "OPTIONAL" && /* @__PURE__ */ a(
        oe,
        {
          name: "checkbox",
          checked: b,
          text: /* @__PURE__ */ a("span", { className: s["checkbox-text-wrapper"], children: n("web.share.reg.type") }),
          onClick: (e) => {
            var w;
            const o = e.target;
            $(!b), T(o.checked ? (w = c[0]) == null ? void 0 : w.type : void 0);
          }
        }
      ),
      L && D(),
      G && /* @__PURE__ */ f("div", { className: `${s["sharebar-radio-error"]}`, children: [
        /* @__PURE__ */ a(se, { iconName: "triangle-exclamation", theme: u.RED }),
        /* @__PURE__ */ a("span", { className: `${s["sharebar-sub-error"]}`, "data-testid": "registration-error-message", "data-pod-name": "commerce", children: n("web.share.reg.type.message") })
      ] })
    ] }),
    V && K(),
    /* @__PURE__ */ a(
      fe,
      {
        socialLinkHandler: Q,
        socialIconsVisibility: z,
        regType: C,
        existingSharecode: r == null ? void 0 : r.sharecode,
        linkProps: g,
        shareTextMessage: B
      }
    )
  ] });
};
export {
  ta as default
};
//# sourceMappingURL=ShareModal.js.map
